import React from 'react';
import { colors } from '@mui/material';
import clsx from 'clsx';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Transition from '@mui/material/Grow';
import LoginIcon from '@mui/icons-material/Login';
import ErrorIcon from '@mui/icons-material/Error';
import Button from '@mui/material/Button';
import Background from '@gobo/gobo.react/lib/core/Background';
import { useTitle } from 'react-use';

const useStyles = makeStyles((theme) => ({
  root: {},
  color: {
    color: theme.palette.error.main,
  },
  icon: {
    // color: theme.palette.white,
    fontSize: theme.typography.h2.fontSize,
  },
  text: {
    // color: theme.palette.white,
  },
  title: {
    fontSize: 50,
  },
  error: {
    width: '50%',
    margin: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
  },
  button: {
    // color: theme.palette.white,
    lineHeight: 'initial',
    // borderColor: theme.palette.white,
    marginLeft: theme.spacing(2),
  },
  accordion: {
    background: 'transparent',
    marginBottom: theme.spacing(2),
    maxWidth: 850,
    borderRadius: 4,
    boxShadow: 'none',
    transition: 'background 0.2s ease',
    '&.Mui-expanded': {
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.error.dark}`,
    },
    '&:before': {
      background: 'none',
    },
    '& .MuiTypography-root': {
      color: theme.palette.white,
    },
    '& .MuiAccordionSummary-root': {
      '& .MuiAccordionSummary-expandIcon': {
        color: theme.palette.white,
      },
    },
  },
}));

export const ReactError = (props) => {
  const classes = useStyles();
  useTitle('Something Went Wrong');
  return (
    <Box
      id='fatal'
      display='flex'
      justifyContent='center'
      alignItems='center'
      flexDirection='column'
      minHeight='100vh'>
      <Background background={colors.teal[50]} />
      <Transition in={true} timeout={1000} mountOnEnter unmountOnExit>
        <ErrorIcon className={clsx(classes.icon, classes.color)} />
      </Transition>
      <Typography className={classes.color} paragraph variant='h2'>
        SOMETHING WENT WRONG
      </Typography>
      <Typography className={classes.color} gutterBottom paragraph>
        The application has encountered an unknown error. Please contact{' '}
        <span style={{ textDecoration: 'underline', fontWeight: 'bolder' }}>
          <Link href='mailto:gobo.help@secunetics.com' color='error'>
            gobo.help@secunetics.com
          </Link>
        </span>{' '}
        to resolve this issue.
      </Typography>
      <Box>
        <Button
          variant='outlined'
          onClick={() => (window.location = '/')}
          size='large'
          startIcon={<LoginIcon />}
          color='error'
          className={classes.button}>
          Login
        </Button>
      </Box>
    </Box>
  );
};

ReactError.defaultProps = {
  error: null,
};

